<template>
  <modal
    :header="true"
    :footer="true"
    :transition-name="transitionName"
    :close-button="true"
    disable-click-outside
    class="social-modal"
    auto-height
    data-test="graphics-socialContentTypeModal"
    @close="onCancel"
  >
    <template #modal-header>
      <h3>Social Content Type</h3>
    </template>
    <template #modal-body>
      <p class="social-modal__description">
        Select the type of content you want to display.
      </p>
      <div class="social-modal__types">
        <label
          v-for="(option, key) in socialTemplate.options"
          :key="key"
          class="social-modal__types-option"
        >
          <input
            :id="key"
            v-model="selectedOption"
            type="radio"
            name="social-type"
            :data-test="`graphics-${action}-select${upperFirst(key)}`"
            :data-entity="`graphics-${action}-select${upperFirst(key)}`"
            :value="key"
            class="hidden-radio"
            tabindex="0"
          >
          <span class="radio-icon" />
          <span class="social-modal__option-content">
            <span class="social-modal__radio-title">{{ option.title }}</span>
            <br>
            <span
              class="social-modal__input-description"
              v-html="option.description"
            />

            <span
              v-if="option.title === 'Media Only'"
              class="social-modal__label-special"
            >*Attribution is required</span>
            <span :class="option.icon" />
          </span>
          <img
            :src="option.img"
            :alt="option.title"
          >
        </label>
      </div>
    </template>
    <template #modal-footer>
      <button
        class="btn btn-style-a no-tooltip"
        :data-test="`graphics-${action}-addSocialTemplate`"
        :data-entity="`graphics-${action}-addSocialTemplate`"
        @click="sendSelections"
      >
        Add Template
      </button>
    </template>
  </modal>
</template>

<script>
import { upperFirst } from 'lodash-es';
import Modal from './Modal.vue';

export default {
  emits: ['close', 'template-selections'],
  components: {
    Modal,
  },
  props: {
    socialTemplate: { type: Object, required: true },
    action: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      transitionName: 'modal-form__slide',
      selectedOption: '',
    };
  },
  methods: {
    upperFirst,
    onCancel() {
      this.$emit('close');
    },
    sendSelections() {
      const { template } = this.socialTemplate;
      const option = this.selectedOption;

      if (!this.socialTemplate.template || !this.selectedOption) return;

      this.$emit('template-selections', { template, option });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.social-modal {
  &__description {
    font-size: 14px;
    font-weight: normal;
  }

  &__types {
    margin-top: 20px;
  }
  &__types-option {
    display: grid;
    grid-template-columns: 0fr .5fr 3fr 2fr;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-evenly;
    cursor: pointer;
    font-size: 16px;
    user-select: none;

    &:last-child {
      margin-bottom: 0;
    }

    /* Hide the default radio button */
    .hidden-radio {
      opacity: 0;
      width: 0;
    }

    /* Style the custom radio icon */
    .radio-icon {
      position: relative;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 2px solid #cbcbcb;
      background-color: transparent;
      margin-right: 8px;
      transition: border-color 0.3s ease, background-color 0.3s ease;
    }

    & input[type='radio']:checked + .radio-icon {
      border-color: white;
      background-color: #2288a0;
      box-shadow: 0 0 5px #2288a0;
      outline: 2px solid #2288a0;
    }
    // add focus state
    & input[type='radio']:focus + .radio-icon {
      outline: none;
      border-color: #2288a0;
    }
    /* Style the label text */
    &:hover .radio-icon {
      border-color: #036076; /* Border color on hover */
    }

    /* Remove default radio button outline on focus */
    & input[type='radio']:focus + .radio-icon {
      outline: none;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  &__radio-title {
    font-size: 15px;
    font-weight: bold;
  }

  &__input-description {
    font-size: 12px;
    font-weight: normal;
    margin-top: 0.5rem;
    line-height: 1.3;
    display: block;
  }

  &__label-special {
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    color: #2288a0;
  }

  &.modal-footer {
    position: absolute;
    display: flex;
    flex-direction: row;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 2rem;
    justify-content: end;
    align-items: center;

    button {
      margin-left: 1rem;
    }
    .btn-style-a {
      background-color: #2bacca;
      border: 2px solid #2bacca;
      border-radius: 2px;
      padding: 10px 15px;
      font-size: 14px;
      font-weight: 700;
      color: white;

      &:hover {
        background-color: #2288a0;
        border-color: #2288a0;
      }
    }
  }
}
</style>
